import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import ecoFlow from "./ecoFlow.js";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-keyword', label: '사업장명', value: '사업장명', query: {'fil_1': 'keyword'}, options: {
          default: '',
        }
      },
      {
        'component': 'search-keyword', label: '공정명', value: '공정명', query: {'fil_2': 'keyword'}, options: {
          default: '',
        }
      },
      {
        'component': 'search-keyword', label: '공정번호', value: '공정번호', query: {'fil_3': 'keyword'}, options: {
          default: '',
        }
      },
      {
        'component': 'search-keyword', label: '관리번호', value: '관리번호', query: {'fil_4': 'keyword'}, options: {
          default: '',
        }
      },
      {
        'component': 'search-keyword', label: '시설명', value: '시설명', query: {'fil_5': 'keyword'}, options: {
          default: '',
        }
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.사업장명) {
      conditions.push({
        key: 'body.stdInfo.field_name',
        value: `%${search.사업장명}%`,
        operator: 'LIKE'
      });
    }

    const searchValues = ecoFlow.findItems(search.공정명)
    if (search.공정명 && searchValues.length > 0) {
      conditions.push({
        key: 'body.시설정보.공정명',
        value: searchValues.map(item => item.value),
        operator: 'IN'
      });
    }

    if (search.공정번호) {
      conditions.push({
        key: 'body.시설정보.공정번호',
        value: `%${search.공정번호}%`,
        operator: 'LIKE'
      });
    }

    if (search.관리번호) {
      conditions.push({
        key: 'body.시설정보.관리번호',
        value: `%${search.관리번호}%`,
        operator: 'LIKE'
      });
    }

    if (search.시설명) {
      conditions.push({
        key: 'body.시설정보.시설명',
        value: `%${search.시설명}%`,
        operator: 'LIKE'
      });
    }

    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "공정명",
        key: "body.시설정보.공정명",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "공정번호",
        key: "body.시설정보.공정번호",
      },
      {
        name: "관리번호",
        key: "body.시설정보.관리번호",
      },
      {
        name: "시설명",
        key: "body.시설정보.시설명",
      },
      {
        name: "용량",
        key: "body.시설정보.용량",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 0) {
          return func.getContent(value).시설정보 ? ecoFlow.getLabel(func.getContent(value).시설정보.공정명) : '';
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }

    } catch (e) {}
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
